(function () {
  var SELECTOR = [
    '.product-card-wrapper .card__media img',
    '[class*="gallery-image-"] img',
    '[class*="air-jordan-3-image-"] img'
  ].join(',');
  var FALLBACK_COLOR = '#ffffff';
  var cache = new Map();
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext && canvas.getContext('2d');

  function schedule(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 1200 });
      return;
    }

    window.requestAnimationFrame(callback);
  }

  function getImageUrl(image) {
    return image.currentSrc || image.src || image.getAttribute('src');
  }

  function median(values) {
    values.sort(function (a, b) {
      return a - b;
    });
    return values[Math.floor(values.length / 2)];
  }

  function colorFromPixels(pixels) {
    if (!pixels.length) return FALLBACK_COLOR;

    return 'rgb(' + [
      median(pixels.map(function (pixel) { return pixel[0]; })),
      median(pixels.map(function (pixel) { return pixel[1]; })),
      median(pixels.map(function (pixel) { return pixel[2]; }))
    ].join(', ') + ')';
  }

  function sampleImage(probe) {
    var width = Math.max(1, Math.min(80, probe.naturalWidth || probe.width));
    var height = Math.max(1, Math.min(80, probe.naturalHeight || probe.height));
    var sourceWidth = probe.naturalWidth || probe.width;
    var sourceHeight = probe.naturalHeight || probe.height;
    var cornerSize = Math.max(4, Math.round(Math.min(width, height) * 0.12));
    var cornerStarts = [
      [0, 0],
      [width - cornerSize, 0],
      [0, height - cornerSize],
      [width - cornerSize, height - cornerSize]
    ];
    var pixels = [];

    canvas.width = width;
    canvas.height = height;
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(probe, 0, 0, sourceWidth, sourceHeight, 0, 0, width, height);

    cornerStarts.forEach(function (start) {
      var imageData = ctx.getImageData(start[0], start[1], cornerSize, cornerSize).data;

      for (var index = 0; index < imageData.length; index += 4) {
        if (imageData[index + 3] > 20) {
          pixels.push([imageData[index], imageData[index + 1], imageData[index + 2]]);
        }
      }
    });

    return colorFromPixels(pixels);
  }

  function applyColor(image, color) {
    var media = image.closest('.card__media, [class*="gallery-image-"], [class*="air-jordan-3-image-"]');
    var card = image.closest('.product-card-wrapper, [class*="gallery-slide-"], [class*="air-jordan-3-slide-"]');

    if (media) {
      media.style.setProperty('--product-card-bg', color);
      media.dataset.productCardBg = color;
    }

    if (card) {
      card.style.setProperty('--product-card-bg', color);
      card.dataset.productCardBg = color;
    }

    var inner = image.closest('.card__inner');
    if (inner) {
      inner.style.setProperty('--product-card-bg', color);
    }
  }

  function detect(image) {
    if (!ctx || !image || image.dataset.productCardBgSampled === 'true') return;

    var url = getImageUrl(image);
    if (!url) {
      applyColor(image, FALLBACK_COLOR);
      return;
    }

    image.dataset.productCardBgSampled = 'true';

    if (cache.has(url)) {
      applyColor(image, cache.get(url));
      return;
    }

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';

    probe.onload = function () {
      var color = FALLBACK_COLOR;

      try {
        color = sampleImage(probe);
      } catch (error) {
        color = FALLBACK_COLOR;
      }

      cache.set(url, color);
      applyColor(image, color);
    };

    probe.onerror = function () {
      cache.set(url, FALLBACK_COLOR);
      applyColor(image, FALLBACK_COLOR);
    };

    probe.src = url;
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll(SELECTOR);

    images.forEach(function (image) {
      schedule(function () {
        if (image.complete) {
          detect(image);
          return;
        }

        image.addEventListener('load', function () {
          detect(image);
        }, { once: true });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
